import { faWrench } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Tooltip, Whisper } from 'rsuite';

export default function updateBusConfig() {
    return (
        <div data-cy="history-tcmCmdBus">
            <Whisper
                placement="right"
                trigger="hover"
                speaker={
                    <Tooltip>
                        <FormattedMessage id="history.tcmCmdBus" />
                    </Tooltip>
                }>
                <FontAwesomeIcon icon={faWrench} size="lg" style={{ color: '#2184da' }} />
            </Whisper>
        </div>
    );
}
